import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/use-auth'
import { Button } from '@/components/ui/button'
import { useToast } from '@/hooks/use-toast'
import { LayoutDashboard, LogOut, FileEdit, BarChart2, Bot } from 'lucide-react'
import { cn } from '@/lib/utils'

export const AdminLayout = () => {
  const { signOut, user } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const { toast } = useToast()

  const handleSignOut = async () => {
    const { error } = await signOut()
    if (error) {
      toast({
        variant: 'destructive',
        title: 'Erro ao sair',
        description: error.message,
      })
    } else {
      navigate('/admin/login')
    }
  }

  const isActive = (path: string) => location.pathname === path

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="container mx-auto px-4 h-16 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <Link
              to="/admin/dashboard"
              className="font-bold text-xl text-slate-900 flex items-center gap-2"
            >
              <LayoutDashboard className="h-6 w-6 text-primary" />
              <span>Backoffice</span>
            </Link>

            <nav className="hidden md:flex items-center gap-1">
              <Link
                to="/admin/dashboard"
                className={cn(
                  'px-3 py-2 rounded-md text-sm font-medium transition-colors',
                  isActive('/admin/dashboard')
                    ? 'bg-slate-100 text-slate-900'
                    : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900',
                )}
              >
                Dashboard
              </Link>
              <Link
                to="/admin/content"
                className={cn(
                  'px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2',
                  isActive('/admin/content')
                    ? 'bg-slate-100 text-slate-900'
                    : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900',
                )}
              >
                <FileEdit className="h-4 w-4" />
                Conteúdos
              </Link>
              <Link
                to="/admin/chatbot"
                className={cn(
                  'px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2',
                  isActive('/admin/chatbot')
                    ? 'bg-slate-100 text-slate-900'
                    : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900',
                )}
              >
                <Bot className="h-4 w-4" />
                Chatbot
              </Link>
              <Link
                to="/admin/analytics/chatbot"
                className={cn(
                  'px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2',
                  isActive('/admin/analytics/chatbot')
                    ? 'bg-slate-100 text-slate-900'
                    : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900',
                )}
              >
                <BarChart2 className="h-4 w-4" />
                Analytics
              </Link>
            </nav>
          </div>

          <div className="flex items-center gap-4">
            <span className="text-sm text-slate-500 hidden md:inline-block">
              {user?.email}
            </span>
            <Button
              variant="outline"
              size="sm"
              onClick={handleSignOut}
              className="gap-2"
            >
              <LogOut className="h-4 w-4" />
              Sair
            </Button>
          </div>
        </div>
      </header>
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  )
}
